import type { WizardStepComponentProps } from '@klear/ui/wizard/flow'
import { COLLECTION_TYPE, COLLECTION_TYPE_LABELS, type CollectionType } from '@/app/collections/steps'
import type { CollectionStepCtx } from '@/app/collections/outlet-context'
import { CircleDollarSign, RotateCcw } from 'lucide-react'

const COLLECTION_OPTIONS: { type: CollectionType; icon: typeof CircleDollarSign; description: string }[] = [
  {
    type: COLLECTION_TYPE.FEES,
    icon: CircleDollarSign,
    description: 'Collect outstanding fees from a trader for an invoice.'
  },
  {
    type: COLLECTION_TYPE.ADVANCE_RECOVERY,
    icon: RotateCcw,
    description: 'Recover the advance amount from a settled invoice.'
  }
]

export default function SelectCollectionTypeStep({ ctx }: WizardStepComponentProps<CollectionStepCtx>) {
  const { state, setState } = ctx

  const onSelect = (type: CollectionType) => {
    setState((s) => ({
      ...s,
      collectionType: type,
      selectedFees: [],
      selectedRecoveries: [],
      paymentDetails: null
    }))
  }

  return (
    <div className="space-y-4 w-full">
      <p className="text-sm text-muted-foreground">What type of collection are you making?</p>
      <div className="grid gap-3">
        {COLLECTION_OPTIONS.map(({ type, icon: Icon, description }) => {
          const selected = state.collectionType === type
          return (
            <button
              key={type}
              type="button"
              onClick={() => onSelect(type)}
              className={`flex items-start gap-3 rounded-lg border p-4 text-left transition-colors ${
                selected
                  ? 'border-primary bg-primary/5 ring-1 ring-primary'
                  : 'border-border hover:border-muted-foreground/30 hover:bg-muted/50'
              }`}
            >
              <Icon className={`h-5 w-5 mt-0.5 shrink-0 ${selected ? 'text-primary' : 'text-muted-foreground'}`} />
              <div>
                <span className={`text-sm font-medium ${selected ? 'text-primary' : 'text-foreground'}`}>
                  {COLLECTION_TYPE_LABELS[type]}
                </span>
                <p className="text-xs text-muted-foreground mt-0.5">{description}</p>
              </div>
            </button>
          )
        })}
      </div>
    </div>
  )
}
